import { useState, useEffect } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addHomeStats = ApiEndpoints.stats.create;
const getHomeStats = ApiEndpoints.stats.edit;
const updateHomeStats = ApiEndpoints.stats.update;

export default function Stats() {

  const [stats, setStats] = useState({
    title1: "",
    value1: "",
    title2: "",
    value2: "",
    title3: "",
    value3: "",
    title4: "",
    value4: "",
  });

  const fetchData = async () => {
    try {
      const response = await ApiRequest("GET", getHomeStats,);
      if (response && response.stat) {
        setStats(response.stat);
      }
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStats((prevStats) => ({
      ...prevStats,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stats.title1 || !stats.value1 || !stats.title2 || !stats.value2 || !stats.title3 || !stats.value3 || !stats.title4 || !stats.value4) {
      toast.error("All the fields of stats are required.");
      return;
    }

    try {
      const endpoint = stats._id ? updateHomeStats : addHomeStats;

      let payload = { ...stats };

      if (stats._id) {
        payload.stat_id = stats._id;
      }

      const response = await ApiRequest("POST", endpoint, payload);


      if (response.error === false) {
        toast.success(response.message);
        fetchData();
      } else {
        toast.error("Failed to save stats. Please try again.");
      }
    } catch (error) {
      console.error("Error saving stats:", error);
    }
  };

  const pagename = {
    name: 'Stats Management',
    user: 'Admin',
    innerpage: 'Stats Management / Our Stats'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 1<small>*</small></label>
                    {/* <span>Numeric</span> */}
                  </div>
                  <input type="text" className="form-control" placeholder="Ex: 500 k+" name="title1" value={stats.title1} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Stat 1 Description<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="value1" value={stats.value1} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 2<small>*</small></label>
                    {/* <span>Numeric</span> */}
                  </div>
                  <input type="text" className="form-control" placeholder="Ex: 500 k+" name="title2" value={stats.title2} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Stat 2 Description<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="value2" value={stats.value2} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 3<small>*</small></label>
                    {/* <span>Numeric</span> */}
                  </div>
                  <input type="text" className="form-control" placeholder="Ex: 500 k+" name="title3" value={stats.title3} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Stat 3 Description<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="value3" value={stats.value3} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Stat 4<small>*</small></label>
                    {/* <span>Numeric</span> */}
                  </div>
                  <input type="text" className="form-control" placeholder="Ex: 500 k+" name="title4" value={stats.title4} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Stat 4 Description<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="value4" value={stats.value4} onChange={handleChange} />
                </div>
              </div>


              <div className="col-lg-12">
                <div className="btn-group-home-solve">
                  <button type="submit" className="default-btn">save <span></span></button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
